import { render, staticRenderFns } from "./TrafficSource.vue?vue&type=template&id=a204c6ae"
import script from "./TrafficSource.vue?vue&type=script&lang=js"
export * from "./TrafficSource.vue?vue&type=script&lang=js"
import style0 from "./TrafficSource.vue?vue&type=style&index=0&id=a204c6ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports